import { useFormContext } from 'react-hook-form';
import { ContentSection, DividerList } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Card, Stack } from '@optimus-web/core';
import { useSelectedRateGroupsContext } from '../../hooks';
import { CENTRAL_RATE_GROUP_ID_FIELD_NAME, FormValues } from '../schema';
import { useCentralRateGroupWithProfilesGet } from '../queries';
import { PaymentPoliciesSection } from './PaymentPoliciesSection';
import { PolicyExceptionsSection } from './PolicyExceptionsSection';
import { CancellationPoliciesSection } from './CancellationPoliciesSection';
import { SettlementConfigurationSection } from './SettlementConfigurationSection';

export const SummaryStepContent = () => {
    const selectedRateGroups = useSelectedRateGroupsContext();
    const { watch } = useFormContext<FormValues>();
    const rateGroupId = watch(CENTRAL_RATE_GROUP_ID_FIELD_NAME);
    const { data } = useCentralRateGroupWithProfilesGet({ rateGroupId });

    if (!data) return null;

    const cancellationPolicies =
        data.centralCancellationPolicies?.map(({ applicability, ...other }) => ({
            ...other,
            applicabilityType: applicability,
        })) ?? [];

    return (
        <Stack spacing="300" vertical>
            <Banner
                primaryText={lt(TextKey.LinkCentralBannerHeading, { count: selectedRateGroups.length })}
                secondaryText={lt(TextKey.LinkCentralBannerBody, { count: selectedRateGroups.length })}
                variant="warning"
            />
            <Card padding="300" cornerRadius="medium">
                <DividerList spacing="300">
                    <SettlementConfigurationSection
                        settlementMaximumTimeUnits={data.settlementMaximumTimeUnits}
                        settlementExtent={data.settlementExtent}
                        options={data.options.filter((option) => option !== 'RequirePaymentCardDuringOnlineCheckIn')}
                    />
                    <ContentSection title={lt('GeneralPolicyPlural')}>
                        <PaymentPoliciesSection settlementRules={data.centralSettlementRules} />
                        <CancellationPoliciesSection cancellationPolicies={cancellationPolicies} />
                        <PolicyExceptionsSection />
                    </ContentSection>
                </DividerList>
            </Card>
        </Stack>
    );
};
